/**
 * EditorUIContext
 *
 * A lightweight React context that provides shared UI callbacks to deep
 * renderer components (LeafRenderer, ElementRenderer, ImageRenderer,
 * CommentGroupOverlay) without prop-drilling through Slate's render API
 * and without a Zustand store.
 *
 * Provided by: DocumentBuilder (in Editor.tsx)
 * Consumed by: any renderer that needs these 3 values
 */

import {createContext, useContext} from 'react';

export interface EditorUIContextValue {
  commentPanelOpen: boolean;
  setCommentPanelOpen: (isOpen: boolean) => void;
  setCroppingImage: (image: {src: string; nodePath: any} | null) => void;
  onCommentAdded: () => void;
}

const defaultValue: EditorUIContextValue = {
  commentPanelOpen: false,
  setCommentPanelOpen: () => {},
  setCroppingImage: () => {},
  onCommentAdded: () => {}
};

export const EditorUIContext =
  createContext<EditorUIContextValue>(defaultValue);

/** Hook for renderer components to consume editor UI callbacks. */
export const useEditorUI = (): EditorUIContextValue =>
  useContext(EditorUIContext);
